import React from "react";
import { formatPrice } from "src/services/number.service";
import { translate } from "src/services/translation.service";
import theme from "src/theme";
import globalTheme from "src/theme";
import styled from "styled-components";

const OriginalPrice = styled.span`
  margin-left: ${theme.margins.marginMedium};
  font-family: ${globalTheme.fonts.light};
  text-decoration: line-through;
`;

interface IPrices {
  actualPrice: number;
  originalPrice: number;
}

const renderOriginalPrice = (
  actualPrice: number,
  originalPrice: number
): JSX.Element | null => {
  if (actualPrice !== originalPrice) {
    return <OriginalPrice>{formatPrice(originalPrice)} €</OriginalPrice>;
  }

  return null;
};

const Price = ({ actualPrice, originalPrice }: IPrices): JSX.Element => {
  // Display "- €", when data (actualPrice & originalPrice equal to 0)
  if (actualPrice === 0 && originalPrice === 0) {
    return <span>- €</span>;
  }

  // Display "From [actualPrice]€"
  if (actualPrice > originalPrice) {
    return <span>{`${translate("product.priceFrom")} ${actualPrice}€`}</span>;
  }

  // Display only actualPrice (if equal to originalPrice)
  // or actualPrice and striketrough originalPrice
  return (
    <>
      {actualPrice && formatPrice(actualPrice) + "€"}
      {renderOriginalPrice(actualPrice, originalPrice)}
    </>
  );
};

export default Price;
